import { DatePipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Note } from '@rocksoft/mdm-sdk-v2';

@Component({
  selector: 'era-note',
  templateUrl: './note.component.html',
  imports: [ReactiveFormsModule, FaIconComponent, DatePipe],
})
export class NoteComponent {
  private readonly formBuilder = inject(UntypedFormBuilder);

  readonly note = input<Note | undefined>(undefined);
  readonly editMode = input(false);

  readonly addedEvent = output<Note>();
  readonly deletedEvent = output<Note>();

  public readonly form: UntypedFormGroup;

  constructor() {
    this.form = this.formBuilder.group({
      content: ['', Validators.required],
    });
  }

  public addNote(): void {
    const content = this.form.get('content')?.value;
    const current = this.note();
    const updatedNote: Note = {
      ...current,
      id: current?.id ?? '', // ID is set in the backend, so when adding a new note, we don't have an ID.
      content,
      updatedAt: new Date().toISOString(),
    };
    this.addedEvent.emit(updatedNote);
    this.form.reset();
  }

  public deleteNote(): void {
    const note = this.note();
    if (note) {
      this.deletedEvent.emit(note);
    }
  }
}
